var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart',{ref:"chartComponent",attrs:{"chartData":_vm.chartData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }